import action from "../helpers/rest-client";
export class ErrorCertification extends Error {}

class Certification {
    public async downloadCertification(courseId: number) {
        return action
        .Get({
            url: `/enrollment/certificate/${courseId}`,
            config: {
                responseType: "blob"
            }
        })
        .then((resp) => {
            return resp;
        })
        .catch((error) => {
            throw new ErrorCertification(error.message);
        });
    }
}

const certification = new Certification();
export default certification;